"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var BoardingPassIcon = function BoardingPassIcon(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 20.8 11.8 C 20.8 10.59 21.79 9.6 23 9.6 V 5.2 C 23 3.99 22.01 3 20.8 3 H 3.2 C 1.99 3 1.011 3.99 1.011 5.2 V 9.6 C 2.221 9.6 3.2 10.59 3.2 11.8 C 3.2 13.01 2.221 14 1 14 V 18.4 C 1 19.61 1.99 20.6 3.2 20.6 H 20.8 C 22.01 20.6 23 19.61 23 18.4 V 14 C 21.79 14 20.8 13.01 20.8 11.8 Z M 17.9617 9.45749 C 17.8432 9.00405 17.3399 8.72065 16.8662 8.86235 L 13.7277 9.65587 L 9.64179 6 L 8.48708 6.2834 L 10.9445 10.336 L 8.01335 11.1012 L 6.85863 10.2227 L 6 10.4494 L 7.06589 12.2348 L 7.51001 13 L 8.45747 12.7449 L 11.5959 11.9514 L 14.1718 11.2996 L 17.3399 10.5061 C 17.8136 10.3644 18.1097 9.91093 17.9617 9.45749 Z M 6 15 H 18 V 16 H 6 V 15 Z",
    fill: "#212124"
  }, colorStyles)));
};
BoardingPassIcon.propTypes = _inline_svg2.default.propTypes;
BoardingPassIcon.defaultProps = _inline_svg2.default.defaultProps;
var _default = BoardingPassIcon;
exports.default = _default;